<template>
  <div class="icon-selector">
    <button class="current-icon" @click="toggleDropdown">
      <span v-if="!isOpen">▼</span>
      <span v-if="isOpen">▲</span>
    </button>

    <div v-if="isOpen" class="icon-dropdown">
      <!-- Campo de búsqueda -->
      <div class="search-container">
        <input
          v-model="searchQuery"
          type="text"
          placeholder="Buscar iconos..."
          class="search-input"
          @input="filterIcons"
        />
        <div class="search-results-count">
          {{ filteredIcons?.length || 0 }} de {{ allIcons?.length || 0 }} iconos
        </div>
      </div>
      
      <!-- Grid de iconos filtrados -->
      <div class="icon-grid">
        <button
            v-for="icon in (filteredIcons || [])"
            :key="icon"
            @click="selectIcon(icon)"
            :class="{ selected: icon === currentIcon }"
            :title="icon"
        >
          <i :class="icon"></i>
        </button>
      </div>
      
      <!-- Mensaje cuando no hay resultados -->
      <div v-if="(filteredIcons?.length || 0) === 0" class="no-results">
        <i class="fa-solid fa-search"></i>
        <p>No se encontraron iconos que coincidan con "{{ searchQuery }}"</p>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, watch, nextTick } from 'vue';

export default {
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    const allIcons = ref([
      'fa-solid fa-ad',
      'fa-solid fa-address-book',
      'fa-solid fa-address-card',
      'fa-solid fa-adjust',
      'fa-solid fa-air-freshener',
      'fa-solid fa-align-center',
      'fa-solid fa-align-justify',
      'fa-solid fa-align-left',
      'fa-solid fa-align-right',
      'fa-solid fa-allergies',
      'fa-solid fa-ambulance',
      'fa-solid fa-american-sign-language-interpreting',
      'fa-solid fa-anchor',
      'fa-solid fa-angle-double-down',
      'fa-solid fa-angle-double-left',
      'fa-solid fa-angle-double-right',
      'fa-solid fa-angle-double-up',
      'fa-solid fa-angle-down',
      'fa-solid fa-angle-left',
      'fa-solid fa-angle-right',
      'fa-solid fa-angle-up',
      'fa-solid fa-angry',
      'fa-solid fa-ankh',
      'fa-solid fa-apple-alt',
      'fa-solid fa-archive',
      'fa-solid fa-archway',
      'fa-solid fa-arrow-alt-circle-down',
      'fa-solid fa-arrow-alt-circle-left',
      'fa-solid fa-arrow-alt-circle-right',
      'fa-solid fa-arrow-alt-circle-up',
      'fa-solid fa-arrow-circle-down',
      'fa-solid fa-arrow-circle-left',
      'fa-solid fa-arrow-circle-right',
      'fa-solid fa-arrow-circle-up',
      'fa-solid fa-arrow-down',
      'fa-solid fa-arrow-left',
      'fa-solid fa-arrow-right',
      'fa-solid fa-arrow-up',
      'fa-solid fa-arrows-alt-h',
      'fa-solid fa-arrows-alt-v',
      'fa-solid fa-arrows-alt',
      'fa-solid fa-assistive-listening-systems',
      'fa-solid fa-asterisk',
      'fa-solid fa-at',
      'fa-solid fa-atlas',
      'fa-solid fa-atom',
      'fa-solid fa-audio-description',
      'fa-solid fa-award',
      'fa-solid fa-baby-carriage',
      'fa-solid fa-baby',
      'fa-solid fa-backspace',
      'fa-solid fa-backward',
      'fa-solid fa-bacon',
      'fa-solid fa-bacteria',
      'fa-solid fa-bacterium',
      'fa-solid fa-bahai',
      'fa-solid fa-balance-scale-left',
      'fa-solid fa-balance-scale-right',
      'fa-solid fa-balance-scale',
      'fa-solid fa-ban',
      'fa-solid fa-band-aid',
      'fa-solid fa-barcode',
      'fa-solid fa-bars',
      'fa-solid fa-baseball-ball',
      'fa-solid fa-basketball-ball',
      'fa-solid fa-bath',
      'fa-solid fa-battery-empty',
      'fa-solid fa-battery-full',
      'fa-solid fa-battery-half',
      'fa-solid fa-battery-quarter',
      'fa-solid fa-battery-three-quarters',
      'fa-solid fa-bed',
      'fa-solid fa-beer',
      'fa-solid fa-bell-slash',
      'fa-solid fa-bell',
      'fa-solid fa-bezier-curve',
      'fa-solid fa-bible',
      'fa-solid fa-bicycle',
      'fa-solid fa-biking',
      'fa-solid fa-binoculars',
      'fa-solid fa-biohazard',
      'fa-solid fa-birthday-cake',
      'fa-solid fa-blender-phone',
      'fa-solid fa-blender',
      'fa-solid fa-blind',
      'fa-solid fa-blog',
      'fa-solid fa-bold',
      'fa-solid fa-bolt',
      'fa-solid fa-bomb',
      'fa-solid fa-bone',
      'fa-solid fa-bong',
      'fa-solid fa-book-dead',
      'fa-solid fa-book-medical',
      'fa-solid fa-book-open',
      'fa-solid fa-book-reader',
      'fa-solid fa-book',
      'fa-solid fa-bookmark',
      'fa-solid fa-border-all',
      'fa-solid fa-border-none',
      'fa-solid fa-border-style',
      'fa-solid fa-bowling-ball',
      'fa-solid fa-box-open',
      'fa-solid fa-box-tissue',
      'fa-solid fa-box',
      'fa-solid fa-boxes',
      'fa-solid fa-braille',
      'fa-solid fa-brain',
      'fa-solid fa-bread-slice',
      'fa-solid fa-briefcase-medical',
      'fa-solid fa-briefcase',
      'fa-solid fa-broadcast-tower',
      'fa-solid fa-broom',
      'fa-solid fa-brush',
      'fa-solid fa-bug',
      'fa-solid fa-building',
      'fa-solid fa-bullhorn',
      'fa-solid fa-bullseye',
      'fa-solid fa-burn',
      'fa-solid fa-bus-alt',
      'fa-solid fa-bus',
      'fa-solid fa-business-time',
      'fa-solid fa-calculator',
      'fa-solid fa-calendar-alt',
      'fa-solid fa-calendar-check',
      'fa-solid fa-calendar-day',
      'fa-solid fa-calendar-minus',
      'fa-solid fa-calendar-plus',
      'fa-solid fa-calendar-times',
      'fa-solid fa-calendar-week',
      'fa-solid fa-calendar',
      'fa-solid fa-camera-retro',
      'fa-solid fa-camera',
      'fa-solid fa-campground',
      'fa-solid fa-candy-cane',
      'fa-solid fa-cannabis',
      'fa-solid fa-capsules',
      'fa-solid fa-car-alt',
      'fa-solid fa-car-battery',
      'fa-solid fa-car-crash',
      'fa-solid fa-car-side',
      'fa-solid fa-car',
      'fa-solid fa-caravan',
      'fa-solid fa-caret-down',
      'fa-solid fa-caret-left',
      'fa-solid fa-caret-right',
      'fa-solid fa-caret-square-down',
      'fa-solid fa-caret-square-left',
      'fa-solid fa-caret-square-right',
      'fa-solid fa-caret-square-up',
      'fa-solid fa-caret-up',
      'fa-solid fa-carrot',
      'fa-solid fa-cart-arrow-down',
      'fa-solid fa-cart-plus',
      'fa-solid fa-cash-register',
      'fa-solid fa-cat',
      'fa-solid fa-certificate',
      'fa-solid fa-chair',
      'fa-solid fa-chalkboard-teacher',
      'fa-solid fa-chalkboard',
      'fa-solid fa-charging-station',
      'fa-solid fa-chart-area',
      'fa-solid fa-chart-bar',
      'fa-solid fa-chart-line',
      'fa-solid fa-chart-pie',
      'fa-solid fa-check-circle',
      'fa-solid fa-check-double',
      'fa-solid fa-check-square',
      'fa-solid fa-check',
      'fa-solid fa-cheese',
      'fa-solid fa-chess-bishop',
      'fa-solid fa-chess-board',
      'fa-solid fa-chess-king',
      'fa-solid fa-chess-knight',
      'fa-solid fa-chess-pawn',
      'fa-solid fa-chess-queen',
      'fa-solid fa-chess-rook',
      'fa-solid fa-chess',
      'fa-solid fa-chevron-circle-down',
      'fa-solid fa-chevron-circle-left',
      'fa-solid fa-chevron-circle-right',
      'fa-solid fa-chevron-circle-up',
      'fa-solid fa-chevron-down',
      'fa-solid fa-chevron-left',
      'fa-solid fa-chevron-right',
      'fa-solid fa-chevron-up',
      'fa-solid fa-child',
      'fa-solid fa-church',
      'fa-solid fa-circle-notch',
      'fa-solid fa-circle',
      'fa-solid fa-city',
      'fa-solid fa-clinic-medical',
      'fa-solid fa-clipboard-check',
      'fa-solid fa-clipboard-list',
      'fa-solid fa-clipboard',
      'fa-solid fa-clock',
      'fa-solid fa-clone',
      'fa-solid fa-closed-captioning',
      'fa-solid fa-cloud-download-alt',
      'fa-solid fa-cloud-meatball',
      'fa-solid fa-cloud-moon-rain',
      'fa-solid fa-cloud-moon',
      'fa-solid fa-cloud-rain',
      'fa-solid fa-cloud-showers-heavy',
      'fa-solid fa-cloud-sun-rain',
      'fa-solid fa-cloud-sun',
      'fa-solid fa-cloud-upload-alt',
      'fa-solid fa-cloud',
      'fa-solid fa-cocktail',
      'fa-solid fa-code-branch',
      'fa-solid fa-code',
      'fa-solid fa-coffee',
      'fa-solid fa-cog',
      'fa-solid fa-cogs',
      'fa-solid fa-coins',
      'fa-solid fa-columns',
      'fa-solid fa-comment-alt',
      'fa-solid fa-comment-dollar',
      'fa-solid fa-comment-dots',
      'fa-solid fa-comment-medical',
      'fa-solid fa-comment-slash',
      'fa-solid fa-comment',
      'fa-solid fa-comments-dollar',
      'fa-solid fa-comments',
      'fa-solid fa-compact-disc',
      'fa-solid fa-compass',
      'fa-solid fa-compress-alt',
      'fa-solid fa-compress-arrows-alt',
      'fa-solid fa-compress',
      'fa-solid fa-concierge-bell',
      'fa-solid fa-cookie-bite',
      'fa-solid fa-cookie',
      'fa-solid fa-copy',
      'fa-solid fa-copyright',
      'fa-solid fa-couch',
      'fa-solid fa-credit-card',
      'fa-solid fa-crop-alt',
      'fa-solid fa-crop',
      'fa-solid fa-cross',
      'fa-solid fa-crosshairs',
      'fa-solid fa-crow',
      'fa-solid fa-crown',
      'fa-solid fa-crutch',
      'fa-solid fa-cube',
      'fa-solid fa-cubes',
      'fa-solid fa-cut',
      'fa-solid fa-database',
      'fa-solid fa-deaf',
      'fa-solid fa-democrat',
      'fa-solid fa-desktop',
      'fa-solid fa-dharmachakra',
      'fa-solid fa-diagnoses',
      'fa-solid fa-dice-d20',
      'fa-solid fa-dice-d6',
      'fa-solid fa-dice-five',
      'fa-solid fa-dice-four',
      'fa-solid fa-dice-one',
      'fa-solid fa-dice-six',
      'fa-solid fa-dice-three',
      'fa-solid fa-dice-two',
      'fa-solid fa-dice',
      'fa-solid fa-digital-tachograph',
      'fa-solid fa-directions',
      'fa-solid fa-disease',
      'fa-solid fa-divide',
      'fa-solid fa-dizzy',
      'fa-solid fa-dna',
      'fa-solid fa-dog',
      'fa-solid fa-dollar-sign',
      'fa-solid fa-dolly-flatbed',
      'fa-solid fa-dolly',
      'fa-solid fa-donate',
      'fa-solid fa-door-closed',
      'fa-solid fa-door-open',
      'fa-solid fa-dot-circle',
      'fa-solid fa-dove',
      'fa-solid fa-download',
      'fa-solid fa-drafting-compass',
      'fa-solid fa-dragon',
      'fa-solid fa-draw-polygon',
      'fa-solid fa-drum-steelpan',
      'fa-solid fa-drum',
      'fa-solid fa-drumstick-bite',
      'fa-solid fa-dumbbell',
      'fa-solid fa-dumpster-fire',
      'fa-solid fa-dumpster',
      'fa-solid fa-dungeon',
      'fa-solid fa-edit',
      'fa-solid fa-egg',
      'fa-solid fa-eject',
      'fa-solid fa-ellipsis-h',
      'fa-solid fa-ellipsis-v',
      'fa-solid fa-envelope-open-text',
      'fa-solid fa-envelope-open',
      'fa-solid fa-envelope-square',
      'fa-solid fa-envelope',
      'fa-solid fa-equals',
      'fa-solid fa-eraser',
      'fa-solid fa-ethernet',
      'fa-solid fa-euro-sign',
      'fa-solid fa-exchange-alt',
      'fa-solid fa-exclamation-circle',
      'fa-solid fa-exclamation-triangle',
      'fa-solid fa-exclamation',
      'fa-solid fa-expand-alt',
      'fa-solid fa-expand-arrows-alt',
      'fa-solid fa-expand',
      'fa-solid fa-external-link-alt',
      'fa-solid fa-external-link-square-alt',
      'fa-solid fa-eye-dropper',
      'fa-solid fa-eye-slash',
      'fa-solid fa-eye',
      'fa-solid fa-fan',
      'fa-solid fa-fast-backward',
      'fa-solid fa-fast-forward',
      'fa-solid fa-faucet',
      'fa-solid fa-fax',
      'fa-solid fa-feather-alt',
      'fa-solid fa-feather',
      'fa-solid fa-female',
      'fa-solid fa-fighter-jet',
      'fa-solid fa-file-alt',
      'fa-solid fa-file-archive',
      'fa-solid fa-file-audio',
      'fa-solid fa-file-code',
      'fa-solid fa-file-contract',
      'fa-solid fa-file-csv',
      'fa-solid fa-file-download',
      'fa-solid fa-file-excel',
      'fa-solid fa-file-export',
      'fa-solid fa-file-image',
      'fa-solid fa-file-import',
      'fa-solid fa-file-invoice-dollar',
      'fa-solid fa-file-invoice',
      'fa-solid fa-file-medical-alt',
      'fa-solid fa-file-medical',
      'fa-solid fa-file-pdf',
      'fa-solid fa-file-powerpoint',
      'fa-solid fa-file-prescription',
      'fa-solid fa-file-signature',
      'fa-solid fa-file-upload',
      'fa-solid fa-file-video',
      'fa-solid fa-file-word',
      'fa-solid fa-file',
      'fa-solid fa-fill-drip',
      'fa-solid fa-fill',
      'fa-solid fa-film',
      'fa-solid fa-filter',
      'fa-solid fa-fingerprint',
      'fa-solid fa-fire-alt',
      'fa-solid fa-fire-extinguisher',
      'fa-solid fa-fire',
      'fa-solid fa-first-aid',
      'fa-solid fa-fish',
      'fa-solid fa-fist-raised',
      'fa-solid fa-flag-checkered',
      'fa-solid fa-flag-usa',
      'fa-solid fa-flag',
      'fa-solid fa-flask',
      'fa-solid fa-flushed',
      'fa-solid fa-folder-minus',
      'fa-solid fa-folder-open',
      'fa-solid fa-folder-plus',
      'fa-solid fa-folder',
      'fa-solid fa-font-awesome-logo-full',
      'fa-solid fa-font',
      'fa-solid fa-football-ball',
      'fa-solid fa-forward',
      'fa-solid fa-frog',
      'fa-solid fa-frown-open',
      'fa-solid fa-frown',
      'fa-solid fa-funnel-dollar',
      'fa-solid fa-futbol',
      'fa-solid fa-gamepad',
      'fa-solid fa-gas-pump',
      'fa-solid fa-gavel',
      'fa-solid fa-gem',
      'fa-solid fa-genderless',
      'fa-solid fa-ghost',
      'fa-solid fa-gift',
      'fa-solid fa-gifts',
      'fa-solid fa-glass-cheers',
      'fa-solid fa-glass-martini-alt',
      'fa-solid fa-glass-martini',
      'fa-solid fa-glass-whiskey',
      'fa-solid fa-glasses',
      'fa-solid fa-globe-africa',
      'fa-solid fa-globe-americas',
      'fa-solid fa-globe-asia',
      'fa-solid fa-globe-europe',
      'fa-solid fa-globe',
      'fa-solid fa-golf-ball',
      'fa-solid fa-gopuram',
      'fa-solid fa-graduation-cap',
      'fa-solid fa-greater-than-equal',
      'fa-solid fa-greater-than',
      'fa-solid fa-grimace',
      'fa-solid fa-grin-alt',
      'fa-solid fa-grin-beam-sweat',
      'fa-solid fa-grin-beam',
      'fa-solid fa-grin-hearts',
      'fa-solid fa-grin-squint-tears',
      'fa-solid fa-grin-squint',
      'fa-solid fa-grin-stars',
      'fa-solid fa-grin-tears',
      'fa-solid fa-grin-tongue-squint',
      'fa-solid fa-grin-tongue-wink',
      'fa-solid fa-grin-tongue',
      'fa-solid fa-grin-wink',
      'fa-solid fa-grin',
      'fa-solid fa-grip-horizontal',
      'fa-solid fa-grip-lines-vertical',
      'fa-solid fa-grip-lines',
      'fa-solid fa-grip-vertical',
      'fa-solid fa-guitar',
      'fa-solid fa-h-square',
      'fa-solid fa-hamburger',
      'fa-solid fa-hammer',
      'fa-solid fa-hamsa',
      'fa-solid fa-hand-holding-heart',
      'fa-solid fa-hand-holding-medical',
      'fa-solid fa-hand-holding-usd',
      'fa-solid fa-hand-holding-water',
      'fa-solid fa-hand-holding',
      'fa-solid fa-hand-lizard',
      'fa-solid fa-hand-middle-finger',
      'fa-solid fa-hand-paper',
      'fa-solid fa-hand-peace',
      'fa-solid fa-hand-point-down',
      'fa-solid fa-hand-point-left',
      'fa-solid fa-hand-point-right',
      'fa-solid fa-hand-point-up',
      'fa-solid fa-hand-pointer',
      'fa-solid fa-hand-rock',
      'fa-solid fa-hand-scissors',
      'fa-solid fa-hand-sparkles',
      'fa-solid fa-hand-spock',
      'fa-solid fa-hands-helping',
      'fa-solid fa-hands-wash',
      'fa-solid fa-hands',
      'fa-solid fa-handshake-alt-slash',
      'fa-solid fa-handshake-slash',
      'fa-solid fa-handshake',
      'fa-solid fa-hanukiah',
      'fa-solid fa-hard-hat',
      'fa-solid fa-hashtag',
      'fa-solid fa-hat-cowboy-side',
      'fa-solid fa-hat-cowboy',
      'fa-solid fa-hat-wizard',
      'fa-solid fa-hdd',
      'fa-solid fa-head-side-cough-slash',
      'fa-solid fa-head-side-cough',
      'fa-solid fa-head-side-mask',
      'fa-solid fa-head-side-virus',
      'fa-solid fa-heading',
      'fa-solid fa-headphones-alt',
      'fa-solid fa-headphones',
      'fa-solid fa-headset',
      'fa-solid fa-heart-broken',
      'fa-solid fa-heart',
      'fa-solid fa-heartbeat',
      'fa-solid fa-helicopter',
      'fa-solid fa-highlighter',
      'fa-solid fa-hiking',
      'fa-solid fa-hippo',
      'fa-solid fa-history',
      'fa-solid fa-hockey-puck',
      'fa-solid fa-holly-berry',
      'fa-solid fa-home',
      'fa-solid fa-horse-head',
      'fa-solid fa-horse',
      'fa-solid fa-hospital-alt',
      'fa-solid fa-hospital-symbol',
      'fa-solid fa-hospital-user',
      'fa-solid fa-hospital',
      'fa-solid fa-hot-tub',
      'fa-solid fa-hotdog',
      'fa-solid fa-hotel',
      'fa-solid fa-hourglass-end',
      'fa-solid fa-hourglass-half',
      'fa-solid fa-hourglass-start',
      'fa-solid fa-hourglass',
      'fa-solid fa-house-damage',
      'fa-solid fa-house-user',
      'fa-solid fa-hryvnia',
      'fa-solid fa-i-cursor',
      'fa-solid fa-ice-cream',
      'fa-solid fa-icicles',
      'fa-solid fa-icons',
      'fa-solid fa-id-badge',
      'fa-solid fa-id-card-alt',
      'fa-solid fa-id-card',
      'fa-solid fa-igloo',
      'fa-solid fa-image',
      'fa-solid fa-images',
      'fa-solid fa-inbox',
      'fa-solid fa-indent',
      'fa-solid fa-industry',
      'fa-solid fa-infinity',
      'fa-solid fa-info-circle',
      'fa-solid fa-info',
      'fa-solid fa-italic',
      'fa-solid fa-jedi',
      'fa-solid fa-joint',
      'fa-solid fa-journal-whills',
      'fa-solid fa-kaaba',
      'fa-solid fa-key',
      'fa-solid fa-keyboard',
      'fa-solid fa-khanda',
      'fa-solid fa-kiss-beam',
      'fa-solid fa-kiss-wink-heart',
      'fa-solid fa-kiss',
      'fa-solid fa-kiwi-bird',
      'fa-solid fa-landmark',
      'fa-solid fa-language',
      'fa-solid fa-laptop-code',
      'fa-solid fa-laptop-house',
      'fa-solid fa-laptop-medical',
      'fa-solid fa-laptop',
      'fa-solid fa-laugh-beam',
      'fa-solid fa-laugh-squint',
      'fa-solid fa-laugh-wink',
      'fa-solid fa-laugh',
      'fa-solid fa-layer-group',
      'fa-solid fa-leaf',
      'fa-solid fa-lemon',
      'fa-solid fa-less-than-equal',
      'fa-solid fa-less-than',
      'fa-solid fa-level-down-alt',
      'fa-solid fa-level-up-alt',
      'fa-solid fa-life-ring',
      'fa-solid fa-lightbulb',
      'fa-solid fa-link',
      'fa-solid fa-lira-sign',
      'fa-solid fa-list-alt',
      'fa-solid fa-list-ol',
      'fa-solid fa-list-ul',
      'fa-solid fa-list',
      'fa-solid fa-location-arrow',
      'fa-solid fa-lock-open',
      'fa-solid fa-lock',
      'fa-solid fa-long-arrow-alt-down',
      'fa-solid fa-long-arrow-alt-left',
      'fa-solid fa-long-arrow-alt-right',
      'fa-solid fa-long-arrow-alt-up',
      'fa-solid fa-low-vision',
      'fa-solid fa-luggage-cart',
      'fa-solid fa-lungs-virus',
      'fa-solid fa-lungs',
      'fa-solid fa-magic',
      'fa-solid fa-magnet',
      'fa-solid fa-mail-bulk',
      'fa-solid fa-male',
      'fa-solid fa-map-marked-alt',
      'fa-solid fa-map-marked',
      'fa-solid fa-map-marker-alt',
      'fa-solid fa-map-marker',
      'fa-solid fa-map-pin',
      'fa-solid fa-map-signs',
      'fa-solid fa-map',
      'fa-solid fa-marker',
      'fa-solid fa-mars-double',
      'fa-solid fa-mars-stroke-h',
      'fa-solid fa-mars-stroke-v',
      'fa-solid fa-mars-stroke',
      'fa-solid fa-mars',
      'fa-solid fa-mask',
      'fa-solid fa-medal',
      'fa-solid fa-medkit',
      'fa-solid fa-meh-blank',
      'fa-solid fa-meh-rolling-eyes',
      'fa-solid fa-meh',
      'fa-solid fa-memory',
      'fa-solid fa-menorah',
      'fa-solid fa-mercury',
      'fa-solid fa-meteor',
      'fa-solid fa-microchip',
      'fa-solid fa-microphone-alt-slash',
      'fa-solid fa-microphone-alt',
      'fa-solid fa-microphone-slash',
      'fa-solid fa-microphone',
      'fa-solid fa-microscope',
      'fa-solid fa-minus-circle',
      'fa-solid fa-minus-square',
      'fa-solid fa-minus',
      'fa-solid fa-mitten',
      'fa-solid fa-mobile-alt',
      'fa-solid fa-mobile',
      'fa-solid fa-money-bill-alt',
      'fa-solid fa-money-bill-wave-alt',
      'fa-solid fa-money-bill-wave',
      'fa-solid fa-money-bill',
      'fa-solid fa-money-check-alt',
      'fa-solid fa-money-check',
      'fa-solid fa-monument',
      'fa-solid fa-moon',
      'fa-solid fa-mortar-pestle',
      'fa-solid fa-mosque',
      'fa-solid fa-motorcycle',
      'fa-solid fa-mountain',
      'fa-solid fa-mouse-pointer',
      'fa-solid fa-mouse',
      'fa-solid fa-mug-hot',
      'fa-solid fa-music',
      'fa-solid fa-network-wired',
      'fa-solid fa-neuter',
      'fa-solid fa-newspaper',
      'fa-solid fa-not-equal',
      'fa-solid fa-notes-medical',
      'fa-solid fa-object-group',
      'fa-solid fa-object-ungroup',
      'fa-solid fa-oil-can',
      'fa-solid fa-om',
      'fa-solid fa-otter',
      'fa-solid fa-outdent',
      'fa-solid fa-pager',
      'fa-solid fa-paint-brush',
      'fa-solid fa-paint-roller',
      'fa-solid fa-palette',
      'fa-solid fa-pallet',
      'fa-solid fa-paper-plane',
      'fa-solid fa-paperclip',
      'fa-solid fa-parachute-box',
      'fa-solid fa-paragraph',
      'fa-solid fa-parking',
      'fa-solid fa-passport',
      'fa-solid fa-pastafarianism',
      'fa-solid fa-paste',
      'fa-solid fa-pause-circle',
      'fa-solid fa-pause',
      'fa-solid fa-paw',
      'fa-solid fa-peace',
      'fa-solid fa-pen-alt',
      'fa-solid fa-pen-fancy',
      'fa-solid fa-pen-nib',
      'fa-solid fa-pen-square',
      'fa-solid fa-pen',
      'fa-solid fa-pencil-alt',
      'fa-solid fa-pencil-ruler',
      'fa-solid fa-people-arrows',
      'fa-solid fa-people-carry',
      'fa-solid fa-pepper-hot',
      'fa-solid fa-percent',
      'fa-solid fa-percentage',
      'fa-solid fa-person-booth',
      'fa-solid fa-phone-alt',
      'fa-solid fa-phone-slash',
      'fa-solid fa-phone-square-alt',
      'fa-solid fa-phone-square',
      'fa-solid fa-phone-volume',
      'fa-solid fa-phone',
      'fa-solid fa-photo-video',
      'fa-solid fa-piggy-bank',
      'fa-solid fa-pills',
      'fa-solid fa-pizza-slice',
      'fa-solid fa-place-of-worship',
      'fa-solid fa-plane-arrival',
      'fa-solid fa-plane-departure',
      'fa-solid fa-plane-slash',
      'fa-solid fa-plane',
      'fa-solid fa-play-circle',
      'fa-solid fa-play',
      'fa-solid fa-plug',
      'fa-solid fa-plus-circle',
      'fa-solid fa-plus-square',
      'fa-solid fa-plus',
      'fa-solid fa-podcast',
      'fa-solid fa-poll-h',
      'fa-solid fa-poll',
      'fa-solid fa-poo-storm',
      'fa-solid fa-poo',
      'fa-solid fa-poop',
      'fa-solid fa-portrait',
      'fa-solid fa-pound-sign',
      'fa-solid fa-power-off',
      'fa-solid fa-pray',
      'fa-solid fa-praying-hands',
      'fa-solid fa-prescription-bottle-alt',
      'fa-solid fa-prescription-bottle',
      'fa-solid fa-prescription',
      'fa-solid fa-print',
      'fa-solid fa-procedures',
      'fa-solid fa-project-diagram',
      'fa-solid fa-pump-medical',
      'fa-solid fa-pump-soap',
      'fa-solid fa-puzzle-piece',
      'fa-solid fa-qrcode',
      'fa-solid fa-question-circle',
      'fa-solid fa-question',
      'fa-solid fa-quidditch',
      'fa-solid fa-quote-left',
      'fa-solid fa-quote-right',
      'fa-solid fa-quran',
      'fa-solid fa-radiation-alt',
      'fa-solid fa-radiation',
      'fa-solid fa-rainbow',
      'fa-solid fa-random',
      'fa-solid fa-receipt',
      'fa-solid fa-record-vinyl',
      'fa-solid fa-recycle',
      'fa-solid fa-redo-alt',
      'fa-solid fa-redo',
      'fa-solid fa-registered',
      'fa-solid fa-remove-format',
      'fa-solid fa-reply-all',
      'fa-solid fa-reply',
      'fa-solid fa-republican',
      'fa-solid fa-restroom',
      'fa-solid fa-retweet',
      'fa-solid fa-ribbon',
      'fa-solid fa-ring',
      'fa-solid fa-road',
      'fa-solid fa-robot',
      'fa-solid fa-rocket',
      'fa-solid fa-route',
      'fa-solid fa-rss-square',
      'fa-solid fa-rss',
      'fa-solid fa-ruble-sign',
      'fa-solid fa-ruler-combined',
      'fa-solid fa-ruler-horizontal',
      'fa-solid fa-ruler-vertical',
      'fa-solid fa-ruler',
      'fa-solid fa-running',
      'fa-solid fa-rupee-sign',
      'fa-solid fa-sad-cry',
      'fa-solid fa-sad-tear',
      'fa-solid fa-satellite-dish',
      'fa-solid fa-satellite',
      'fa-solid fa-save',
      'fa-solid fa-school',
      'fa-solid fa-screwdriver',
      'fa-solid fa-scroll',
      'fa-solid fa-sd-card',
      'fa-solid fa-search-dollar',
      'fa-solid fa-search-location',
      'fa-solid fa-search-minus',
      'fa-solid fa-search-plus',
      'fa-solid fa-search',
      'fa-solid fa-seedling',
      'fa-solid fa-server',
      'fa-solid fa-shapes',
      'fa-solid fa-share-alt-square',
      'fa-solid fa-share-alt',
      'fa-solid fa-share-square',
      'fa-solid fa-share',
      'fa-solid fa-shekel-sign',
      'fa-solid fa-shield-alt',
      'fa-solid fa-shield-virus',
      'fa-solid fa-ship',
      'fa-solid fa-shipping-fast',
      'fa-solid fa-shoe-prints',
      'fa-solid fa-shopping-bag',
      'fa-solid fa-shopping-basket',
      'fa-solid fa-shopping-cart',
      'fa-solid fa-shower',
      'fa-solid fa-shuttle-van',
      'fa-solid fa-sign-in-alt',
      'fa-solid fa-sign-language',
      'fa-solid fa-sign-out-alt',
      'fa-solid fa-sign',
      'fa-solid fa-signal',
      'fa-solid fa-signature',
      'fa-solid fa-sim-card',
      'fa-solid fa-sink',
      'fa-solid fa-sitemap',
      'fa-solid fa-skating',
      'fa-solid fa-skiing-nordic',
      'fa-solid fa-skiing',
      'fa-solid fa-skull-crossbones',
      'fa-solid fa-skull',
      'fa-solid fa-slash',
      'fa-solid fa-sleigh',
      'fa-solid fa-sliders-h',
      'fa-solid fa-smile-beam',
      'fa-solid fa-smile-wink',
      'fa-solid fa-smile',
      'fa-solid fa-smog',
      'fa-solid fa-smoking-ban',
      'fa-solid fa-smoking',
      'fa-solid fa-sms',
      'fa-solid fa-snowboarding',
      'fa-solid fa-snowflake',
      'fa-solid fa-snowman',
      'fa-solid fa-snowplow',
      'fa-solid fa-soap',
      'fa-solid fa-socks',
      'fa-solid fa-solar-panel',
      'fa-solid fa-sort-alpha-down-alt',
      'fa-solid fa-sort-alpha-down',
      'fa-solid fa-sort-alpha-up-alt',
      'fa-solid fa-sort-alpha-up',
      'fa-solid fa-sort-amount-down-alt',
      'fa-solid fa-sort-amount-down',
      'fa-solid fa-sort-amount-up-alt',
      'fa-solid fa-sort-amount-up',
      'fa-solid fa-sort-down',
      'fa-solid fa-sort-numeric-down-alt',
      'fa-solid fa-sort-numeric-down',
      'fa-solid fa-sort-numeric-up-alt',
      'fa-solid fa-sort-numeric-up',
      'fa-solid fa-sort-up',
      'fa-solid fa-sort',
      'fa-solid fa-spa',
      'fa-solid fa-space-shuttle',
      'fa-solid fa-spell-check',
      'fa-solid fa-spider',
      'fa-solid fa-spinner',
      'fa-solid fa-splotch',
      'fa-solid fa-spray-can',
      'fa-solid fa-square-full',
      'fa-solid fa-square-root-alt',
      'fa-solid fa-square',
      'fa-solid fa-stamp',
      'fa-solid fa-star-and-crescent',
      'fa-solid fa-star-half-alt',
      'fa-solid fa-star-half',
      'fa-solid fa-star-of-david',
      'fa-solid fa-star-of-life',
      'fa-solid fa-star',
      'fa-solid fa-step-backward',
      'fa-solid fa-step-forward',
      'fa-solid fa-stethoscope',
      'fa-solid fa-sticky-note',
      'fa-solid fa-stop-circle',
      'fa-solid fa-stop',
      'fa-solid fa-stopwatch-20',
      'fa-solid fa-stopwatch',
      'fa-solid fa-store-alt-slash',
      'fa-solid fa-store-alt',
      'fa-solid fa-store-slash',
      'fa-solid fa-store',
      'fa-solid fa-stream',
      'fa-solid fa-street-view',
      'fa-solid fa-strikethrough',
      'fa-solid fa-stroopwafel',
      'fa-solid fa-subscript',
      'fa-solid fa-subway',
      'fa-solid fa-suitcase-rolling',
      'fa-solid fa-suitcase',
      'fa-solid fa-sun',
      'fa-solid fa-superscript',
      'fa-solid fa-surprise',
      'fa-solid fa-swatchbook',
      'fa-solid fa-swimmer',
      'fa-solid fa-swimming-pool',
      'fa-solid fa-synagogue',
      'fa-solid fa-sync-alt',
      'fa-solid fa-sync',
      'fa-solid fa-syringe',
      'fa-solid fa-table-tennis',
      'fa-solid fa-table',
      'fa-solid fa-tablet-alt',
      'fa-solid fa-tablet',
      'fa-solid fa-tablets',
      'fa-solid fa-tachometer-alt',
      'fa-solid fa-tag',
      'fa-solid fa-tags',
      'fa-solid fa-tape',
      'fa-solid fa-tasks',
      'fa-solid fa-taxi',
      'fa-solid fa-teeth-open',
      'fa-solid fa-teeth',
      'fa-solid fa-temperature-high',
      'fa-solid fa-temperature-low',
      'fa-solid fa-tenge',
      'fa-solid fa-terminal',
      'fa-solid fa-text-height',
      'fa-solid fa-text-width',
      'fa-solid fa-th-large',
      'fa-solid fa-th-list',
      'fa-solid fa-th',
      'fa-solid fa-theater-masks',
      'fa-solid fa-thermometer-empty',
      'fa-solid fa-thermometer-full',
      'fa-solid fa-thermometer-half',
      'fa-solid fa-thermometer-quarter',
      'fa-solid fa-thermometer-three-quarters',
      'fa-solid fa-thermometer',
      'fa-solid fa-thumbs-down',
      'fa-solid fa-thumbs-up',
      'fa-solid fa-thumbtack',
      'fa-solid fa-ticket-alt',
      'fa-solid fa-times-circle',
      'fa-solid fa-times',
      'fa-solid fa-tint-slash',
      'fa-solid fa-tint',
      'fa-solid fa-tired',
      'fa-solid fa-toggle-off',
      'fa-solid fa-toggle-on',
      'fa-solid fa-toilet-paper-slash',
      'fa-solid fa-toilet-paper',
      'fa-solid fa-toilet',
      'fa-solid fa-toolbox',
      'fa-solid fa-tools',
      'fa-solid fa-tooth',
      'fa-solid fa-torah',
      'fa-solid fa-torii-gate',
      'fa-solid fa-tractor',
      'fa-solid fa-trademark',
      'fa-solid fa-traffic-light',
      'fa-solid fa-trailer',
      'fa-solid fa-train',
      'fa-solid fa-tram',
      'fa-solid fa-transgender-alt',
      'fa-solid fa-transgender',
      'fa-solid fa-trash-alt',
      'fa-solid fa-trash-restore-alt',
      'fa-solid fa-trash-restore',
      'fa-solid fa-trash',
      'fa-solid fa-tree',
      'fa-solid fa-trophy',
      'fa-solid fa-truck-loading',
      'fa-solid fa-truck-monster',
      'fa-solid fa-truck-moving',
      'fa-solid fa-truck-pickup',
      'fa-solid fa-truck',
      'fa-solid fa-tshirt',
      'fa-solid fa-tty',
      'fa-solid fa-tv',
      'fa-solid fa-umbrella-beach',
      'fa-solid fa-umbrella',
      'fa-solid fa-underline',
      'fa-solid fa-undo-alt',
      'fa-solid fa-undo',
      'fa-solid fa-universal-access',
      'fa-solid fa-university',
      'fa-solid fa-unlink',
      'fa-solid fa-unlock-alt',
      'fa-solid fa-unlock',
      'fa-solid fa-upload',
      'fa-solid fa-user-alt-slash',
      'fa-solid fa-user-alt',
      'fa-solid fa-user-astronaut',
      'fa-solid fa-user-check',
      'fa-solid fa-user-circle',
      'fa-solid fa-user-clock',
      'fa-solid fa-user-cog',
      'fa-solid fa-user-edit',
      'fa-solid fa-user-friends',
      'fa-solid fa-user-graduate',
      'fa-solid fa-user-injured',
      'fa-solid fa-user-lock',
      'fa-solid fa-user-md',
      'fa-solid fa-user-minus',
      'fa-solid fa-user-ninja',
      'fa-solid fa-user-nurse',
      'fa-solid fa-user-plus',
      'fa-solid fa-user-secret',
      'fa-solid fa-user-shield',
      'fa-solid fa-user-slash',
      'fa-solid fa-user-tag',
      'fa-solid fa-user-tie',
      'fa-solid fa-user-times',
      'fa-solid fa-user',
      'fa-solid fa-users-cog',
      'fa-solid fa-users-slash',
      'fa-solid fa-users',
      'fa-solid fa-utensil-spoon',
      'fa-solid fa-utensils',
      'fa-solid fa-vector-square',
      'fa-solid fa-venus-double',
      'fa-solid fa-venus-mars',
      'fa-solid fa-venus',
      'fa-solid fa-vest-patches',
      'fa-solid fa-vest',
      'fa-solid fa-vial',
      'fa-solid fa-vials',
      'fa-solid fa-video-slash',
      'fa-solid fa-video',
      'fa-solid fa-vihara',
      'fa-solid fa-virus-slash',
      'fa-solid fa-virus',
      'fa-solid fa-viruses',
      'fa-solid fa-voicemail',
      'fa-solid fa-volleyball-ball',
      'fa-solid fa-volume-down',
      'fa-solid fa-volume-mute',
      'fa-solid fa-volume-off',
      'fa-solid fa-volume-up',
      'fa-solid fa-vote-yea',
      'fa-solid fa-vr-cardboard',
      'fa-solid fa-walking',
      'fa-solid fa-wallet',
      'fa-solid fa-warehouse',
      'fa-solid fa-water',
      'fa-solid fa-wave-square',
      'fa-solid fa-weight-hanging',
      'fa-solid fa-weight',
      'fa-solid fa-wheelchair',
      'fa-solid fa-wifi',
      'fa-solid fa-wind',
      'fa-solid fa-window-close',
      'fa-solid fa-window-maximize',
      'fa-solid fa-window-minimize',
      'fa-solid fa-window-restore',
      'fa-solid fa-wine-bottle',
      'fa-solid fa-wine-glass-alt',
      'fa-solid fa-wine-glass',
      'fa-solid fa-won-sign',
      'fa-solid fa-wrench',
      'fa-solid fa-x-ray',
      'fa-solid fa-yen-sign',
      'fa-solid fa-yin-yang',
      'fa-regular fa-address-book',
      'fa-regular fa-address-card',
      'fa-regular fa-angry',
      'fa-regular fa-arrow-alt-circle-down',
      'fa-regular fa-arrow-alt-circle-left',
      'fa-regular fa-arrow-alt-circle-right',
      'fa-regular fa-arrow-alt-circle-up',
      'fa-regular fa-bell-slash',
      'fa-regular fa-bell',
      'fa-regular fa-bookmark',
      'fa-regular fa-building',
      'fa-regular fa-calendar-alt',
      'fa-regular fa-calendar-check',
      'fa-regular fa-calendar-minus',
      'fa-regular fa-calendar-plus',
      'fa-regular fa-calendar-times',
      'fa-regular fa-calendar',
      'fa-regular fa-caret-square-down',
      'fa-regular fa-caret-square-left',
      'fa-regular fa-caret-square-right',
      'fa-regular fa-caret-square-up',
      'fa-regular fa-chart-bar',
      'fa-regular fa-check-circle',
      'fa-regular fa-check-square',
      'fa-regular fa-circle',
      'fa-regular fa-clipboard',
      'fa-regular fa-clock',
      'fa-regular fa-clone',
      'fa-regular fa-closed-captioning',
      'fa-regular fa-comment-alt',
      'fa-regular fa-comment-dots',
      'fa-regular fa-comment',
      'fa-regular fa-comments',
      'fa-regular fa-compass',
      'fa-regular fa-copy',
      'fa-regular fa-copyright',
      'fa-regular fa-credit-card',
      'fa-regular fa-dizzy',
      'fa-regular fa-dot-circle',
      'fa-regular fa-edit',
      'fa-regular fa-envelope-open',
      'fa-regular fa-envelope',
      'fa-regular fa-eye-slash',
      'fa-regular fa-eye',
      'fa-regular fa-file-alt',
      'fa-regular fa-file-archive',
      'fa-regular fa-file-audio',
      'fa-regular fa-file-code',
      'fa-regular fa-file-excel',
      'fa-regular fa-file-image',
      'fa-regular fa-file-pdf',
      'fa-regular fa-file-powerpoint',
      'fa-regular fa-file-video',
      'fa-regular fa-file-word',
      'fa-regular fa-file',
      'fa-regular fa-flag',
      'fa-regular fa-flushed',
      'fa-regular fa-folder-open',
      'fa-regular fa-folder',
      'fa-regular fa-font-awesome-logo-full',
      'fa-regular fa-frown-open',
      'fa-regular fa-frown',
      'fa-regular fa-futbol',
      'fa-regular fa-gem',
      'fa-regular fa-grimace',
      'fa-regular fa-grin-alt',
      'fa-regular fa-grin-beam-sweat',
      'fa-regular fa-grin-beam',
      'fa-regular fa-grin-hearts',
      'fa-regular fa-grin-squint-tears',
      'fa-regular fa-grin-squint',
      'fa-regular fa-grin-stars',
      'fa-regular fa-grin-tears',
      'fa-regular fa-grin-tongue-squint',
      'fa-regular fa-grin-tongue-wink',
      'fa-regular fa-grin-tongue',
      'fa-regular fa-grin-wink',
      'fa-regular fa-grin',
      'fa-regular fa-hand-lizard',
      'fa-regular fa-hand-paper',
      'fa-regular fa-hand-peace',
      'fa-regular fa-hand-point-down',
      'fa-regular fa-hand-point-left',
      'fa-regular fa-hand-point-right',
      'fa-regular fa-hand-point-up',
      'fa-regular fa-hand-pointer',
      'fa-regular fa-hand-rock',
      'fa-regular fa-hand-scissors',
      'fa-regular fa-hand-spock',
      'fa-regular fa-handshake',
      'fa-regular fa-hdd',
      'fa-regular fa-heart',
      'fa-regular fa-hospital',
      'fa-regular fa-hourglass',
      'fa-regular fa-id-badge',
      'fa-regular fa-id-card',
      'fa-regular fa-image',
      'fa-regular fa-images',
      'fa-regular fa-keyboard',
      'fa-regular fa-kiss-beam',
      'fa-regular fa-kiss-wink-heart',
      'fa-regular fa-kiss',
      'fa-regular fa-laugh-beam',
      'fa-regular fa-laugh-squint',
      'fa-regular fa-laugh-wink',
      'fa-regular fa-laugh',
      'fa-regular fa-lemon',
      'fa-regular fa-life-ring',
      'fa-regular fa-lightbulb',
      'fa-regular fa-list-alt',
      'fa-regular fa-map',
      'fa-regular fa-meh-blank',
      'fa-regular fa-meh-rolling-eyes',
      'fa-regular fa-meh',
      'fa-regular fa-minus-square',
      'fa-regular fa-money-bill-alt',
      'fa-regular fa-moon',
      'fa-regular fa-newspaper',
      'fa-regular fa-object-group',
      'fa-regular fa-object-ungroup',
      'fa-regular fa-paper-plane',
      'fa-regular fa-pause-circle',
      'fa-regular fa-play-circle',
      'fa-regular fa-plus-square',
      'fa-regular fa-question-circle',
      'fa-regular fa-registered',
      'fa-regular fa-sad-cry',
      'fa-regular fa-sad-tear',
      'fa-regular fa-save',
      'fa-regular fa-share-square',
      'fa-regular fa-smile-beam',
      'fa-regular fa-smile-wink',
      'fa-regular fa-smile',
      'fa-regular fa-snowflake',
      'fa-regular fa-square',
      'fa-regular fa-star-half',
      'fa-regular fa-star',
      'fa-regular fa-sticky-note',
      'fa-regular fa-stop-circle',
      'fa-regular fa-sun',
      'fa-regular fa-surprise',
      'fa-regular fa-thumbs-down',
      'fa-regular fa-thumbs-up',
      'fa-regular fa-times-circle',
      'fa-regular fa-tired',
      'fa-regular fa-trash-alt',
      'fa-regular fa-user-circle',
      'fa-regular fa-user',
      'fa-regular fa-window-close',
      'fa-regular fa-window-maximize',
      'fa-regular fa-window-minimize',
      'fa-regular fa-window-restore',
      'fa-brands fa-500px',
      'fa-brands fa-accessible-icon',
      'fa-brands fa-accusoft',
      'fa-brands fa-acquisitions-incorporated',
      'fa-brands fa-adn',
      'fa-brands fa-adversal',
      'fa-brands fa-affiliatetheme',
      'fa-brands fa-airbnb',
      'fa-brands fa-algolia',
      'fa-brands fa-alipay',
      'fa-brands fa-amazon-pay',
      'fa-brands fa-amazon',
      'fa-brands fa-amilia',
      'fa-brands fa-android',
      'fa-brands fa-angellist',
      'fa-brands fa-angrycreative',
      'fa-brands fa-angular',
      'fa-brands fa-app-store-ios',
      'fa-brands fa-app-store',
      'fa-brands fa-apper',
      'fa-brands fa-apple-pay',
      'fa-brands fa-apple',
      'fa-brands fa-artstation',
      'fa-brands fa-asymmetrik',
      'fa-brands fa-atlassian',
      'fa-brands fa-audible',
      'fa-brands fa-autoprefixer',
      'fa-brands fa-avianex',
      'fa-brands fa-aviato',
      'fa-brands fa-aws',
      'fa-brands fa-bandcamp',
      'fa-brands fa-battle-net',
      'fa-brands fa-behance-square',
      'fa-brands fa-behance',
      'fa-brands fa-bimobject',
      'fa-brands fa-bitbucket',
      'fa-brands fa-bitcoin',
      'fa-brands fa-bity',
      'fa-brands fa-black-tie',
      'fa-brands fa-blackberry',
      'fa-brands fa-blogger-b',
      'fa-brands fa-blogger',
      'fa-brands fa-bluetooth-b',
      'fa-brands fa-bluetooth',
      'fa-brands fa-bootstrap',
      'fa-brands fa-btc',
      'fa-brands fa-buffer',
      'fa-brands fa-buromobelexperte',
      'fa-brands fa-buy-n-large',
      'fa-brands fa-buysellads',
      'fa-brands fa-canadian-maple-leaf',
      'fa-brands fa-cc-amazon-pay',
      'fa-brands fa-cc-amex',
      'fa-brands fa-cc-apple-pay',
      'fa-brands fa-cc-diners-club',
      'fa-brands fa-cc-discover',
      'fa-brands fa-cc-jcb',
      'fa-brands fa-cc-mastercard',
      'fa-brands fa-cc-paypal',
      'fa-brands fa-cc-stripe',
      'fa-brands fa-cc-visa',
      'fa-brands fa-centercode',
      'fa-brands fa-centos',
      'fa-brands fa-chrome',
      'fa-brands fa-chromecast',
      'fa-brands fa-cloudflare',
      'fa-brands fa-cloudscale',
      'fa-brands fa-cloudsmith',
      'fa-brands fa-cloudversify',
      'fa-brands fa-codepen',
      'fa-brands fa-codiepie',
      'fa-brands fa-confluence',
      'fa-brands fa-connectdevelop',
      'fa-brands fa-contao',
      'fa-brands fa-cotton-bureau',
      'fa-brands fa-cpanel',
      'fa-brands fa-creative-commons-by',
      'fa-brands fa-creative-commons-nc-eu',
      'fa-brands fa-creative-commons-nc-jp',
      'fa-brands fa-creative-commons-nc',
      'fa-brands fa-creative-commons-nd',
      'fa-brands fa-creative-commons-pd-alt',
      'fa-brands fa-creative-commons-pd',
      'fa-brands fa-creative-commons-remix',
      'fa-brands fa-creative-commons-sa',
      'fa-brands fa-creative-commons-sampling-plus',
      'fa-brands fa-creative-commons-sampling',
      'fa-brands fa-creative-commons-share',
      'fa-brands fa-creative-commons-zero',
      'fa-brands fa-creative-commons',
      'fa-brands fa-critical-role',
      'fa-brands fa-css3-alt',
      'fa-brands fa-css3',
      'fa-brands fa-cuttlefish',
      'fa-brands fa-d-and-d-beyond',
      'fa-brands fa-d-and-d',
      'fa-brands fa-dailymotion',
      'fa-brands fa-dashcube',
      'fa-brands fa-deezer',
      'fa-brands fa-delicious',
      'fa-brands fa-deploydog',
      'fa-brands fa-deskpro',
      'fa-brands fa-dev',
      'fa-brands fa-deviantart',
      'fa-brands fa-dhl',
      'fa-brands fa-diaspora',
      'fa-brands fa-digg',
      'fa-brands fa-digital-ocean',
      'fa-brands fa-discord',
      'fa-brands fa-discourse',
      'fa-brands fa-dochub',
      'fa-brands fa-docker',
      'fa-brands fa-draft2digital',
      'fa-brands fa-dribbble-square',
      'fa-brands fa-dribbble',
      'fa-brands fa-dropbox',
      'fa-brands fa-drupal',
      'fa-brands fa-dyalog',
      'fa-brands fa-earlybirds',
      'fa-brands fa-ebay',
      'fa-brands fa-edge-legacy',
      'fa-brands fa-edge',
      'fa-brands fa-elementor',
      'fa-brands fa-ello',
      'fa-brands fa-ember',
      'fa-brands fa-empire',
      'fa-brands fa-envira',
      'fa-brands fa-erlang',
      'fa-brands fa-ethereum',
      'fa-brands fa-etsy',
      'fa-brands fa-evernote',
      'fa-brands fa-expeditedssl',
      'fa-brands fa-facebook-f',
      'fa-brands fa-facebook-messenger',
      'fa-brands fa-facebook-square',
      'fa-brands fa-facebook',
      'fa-brands fa-fantasy-flight-games',
      'fa-brands fa-fedex',
      'fa-brands fa-fedora',
      'fa-brands fa-figma',
      'fa-brands fa-firefox-browser',
      'fa-brands fa-firefox',
      'fa-brands fa-first-order-alt',
      'fa-brands fa-first-order',
      'fa-brands fa-firstdraft',
      'fa-brands fa-flickr',
      'fa-brands fa-flipboard',
      'fa-brands fa-fly',
      'fa-brands fa-font-awesome-alt',
      'fa-brands fa-font-awesome-flag',
      'fa-brands fa-font-awesome-logo-full',
      'fa-brands fa-font-awesome',
      'fa-brands fa-fonticons-fi',
      'fa-brands fa-fonticons',
      'fa-brands fa-fort-awesome-alt',
      'fa-brands fa-fort-awesome',
      'fa-brands fa-forumbee',
      'fa-brands fa-foursquare',
      'fa-brands fa-free-code-camp',
      'fa-brands fa-freebsd',
      'fa-brands fa-fulcrum',
      'fa-brands fa-galactic-republic',
      'fa-brands fa-galactic-senate',
      'fa-brands fa-get-pocket',
      'fa-brands fa-gg-circle',
      'fa-brands fa-gg',
      'fa-brands fa-git-alt',
      'fa-brands fa-git-square',
      'fa-brands fa-git',
      'fa-brands fa-github-alt',
      'fa-brands fa-github-square',
      'fa-brands fa-github',
      'fa-brands fa-gitkraken',
      'fa-brands fa-gitlab',
      'fa-brands fa-gitter',
      'fa-brands fa-glide-g',
      'fa-brands fa-glide',
      'fa-brands fa-gofore',
      'fa-brands fa-goodreads-g',
      'fa-brands fa-goodreads',
      'fa-brands fa-google-drive',
      'fa-brands fa-google-pay',
      'fa-brands fa-google-play',
      'fa-brands fa-google-plus-g',
      'fa-brands fa-google-plus-square',
      'fa-brands fa-google-plus',
      'fa-brands fa-google-wallet',
      'fa-brands fa-google',
      'fa-brands fa-gratipay',
      'fa-brands fa-grav',
      'fa-brands fa-gripfire',
      'fa-brands fa-grunt',
      'fa-brands fa-guilded',
      'fa-brands fa-gulp',
      'fa-brands fa-hacker-news-square',
      'fa-brands fa-hacker-news',
      'fa-brands fa-hackerrank',
      'fa-brands fa-hips',
      'fa-brands fa-hire-a-helper',
      'fa-brands fa-hive',
      'fa-brands fa-hooli',
      'fa-brands fa-hornbill',
      'fa-brands fa-hotjar',
      'fa-brands fa-houzz',
      'fa-brands fa-html5',
      'fa-brands fa-hubspot',
      'fa-brands fa-ideal',
      'fa-brands fa-imdb',
      'fa-brands fa-innosoft',
      'fa-brands fa-instagram-square',
      'fa-brands fa-instagram',
      'fa-brands fa-instalod',
      'fa-brands fa-intercom',
      'fa-brands fa-internet-explorer',
      'fa-brands fa-invision',
      'fa-brands fa-ioxhost',
      'fa-brands fa-itch-io',
      'fa-brands fa-itunes-note',
      'fa-brands fa-itunes',
      'fa-brands fa-java',
      'fa-brands fa-jedi-order',
      'fa-brands fa-jenkins',
      'fa-brands fa-jira',
      'fa-brands fa-joget',
      'fa-brands fa-joomla',
      'fa-brands fa-js-square',
      'fa-brands fa-js',
      'fa-brands fa-jsfiddle',
      'fa-brands fa-kaggle',
      'fa-brands fa-keybase',
      'fa-brands fa-keycdn',
      'fa-brands fa-kickstarter-k',
      'fa-brands fa-kickstarter',
      'fa-brands fa-korvue',
      'fa-brands fa-laravel',
      'fa-brands fa-lastfm-square',
      'fa-brands fa-lastfm',
      'fa-brands fa-leanpub',
      'fa-brands fa-less',
      'fa-brands fa-line',
      'fa-brands fa-linkedin-in',
      'fa-brands fa-linkedin',
      'fa-brands fa-linode',
      'fa-brands fa-linux',
      'fa-brands fa-lyft',
      'fa-brands fa-magento',
      'fa-brands fa-mailchimp',
      'fa-brands fa-mandalorian',
      'fa-brands fa-markdown',
      'fa-brands fa-mastodon',
      'fa-brands fa-maxcdn',
      'fa-brands fa-mdb',
      'fa-brands fa-medapps',
      'fa-brands fa-medium-m',
      'fa-brands fa-medium',
      'fa-brands fa-medrt',
      'fa-brands fa-meetup',
      'fa-brands fa-megaport',
      'fa-brands fa-mendeley',
      'fa-brands fa-microblog',
      'fa-brands fa-microsoft',
      'fa-brands fa-mix',
      'fa-brands fa-mixcloud',
      'fa-brands fa-mixer',
      'fa-brands fa-mizuni',
      'fa-brands fa-modx',
      'fa-brands fa-monero',
      'fa-brands fa-napster',
      'fa-brands fa-neos',
      'fa-brands fa-nimblr',
      'fa-brands fa-node-js',
      'fa-brands fa-node',
      'fa-brands fa-npm',
      'fa-brands fa-ns8',
      'fa-brands fa-nutritionix',
      'fa-brands fa-octopus-deploy',
      'fa-brands fa-odnoklassniki-square',
      'fa-brands fa-odnoklassniki',
      'fa-brands fa-old-republic',
      'fa-brands fa-opencart',
      'fa-brands fa-openid',
      'fa-brands fa-opera',
      'fa-brands fa-optin-monster',
      'fa-brands fa-orcid',
      'fa-brands fa-osi',
      'fa-brands fa-page4',
      'fa-brands fa-pagelines',
      'fa-brands fa-palfed',
      'fa-brands fa-patreon',
      'fa-brands fa-paypal',
      'fa-brands fa-penny-arcade',
      'fa-brands fa-perbyte',
      'fa-brands fa-periscope',
      'fa-brands fa-phabricator',
      'fa-brands fa-phoenix-framework',
      'fa-brands fa-phoenix-squadron',
      'fa-brands fa-php',
      'fa-brands fa-pied-piper-alt',
      'fa-brands fa-pied-piper-hat',
      'fa-brands fa-pied-piper-pp',
      'fa-brands fa-pied-piper-square',
      'fa-brands fa-pied-piper',
      'fa-brands fa-pinterest-p',
      'fa-brands fa-pinterest-square',
      'fa-brands fa-pinterest',
      'fa-brands fa-playstation',
      'fa-brands fa-product-hunt',
      'fa-brands fa-pushed',
      'fa-brands fa-python',
      'fa-brands fa-qq',
      'fa-brands fa-quinscape',
      'fa-brands fa-quora',
      'fa-brands fa-r-project',
      'fa-brands fa-raspberry-pi',
      'fa-brands fa-ravelry',
      'fa-brands fa-react',
      'fa-brands fa-reacteurope',
      'fa-brands fa-readme',
      'fa-brands fa-rebel',
      'fa-brands fa-red-river',
      'fa-brands fa-reddit-alien',
      'fa-brands fa-reddit-square',
      'fa-brands fa-reddit',
      'fa-brands fa-redhat',
      'fa-brands fa-renren',
      'fa-brands fa-replyd',
      'fa-brands fa-researchgate',
      'fa-brands fa-resolving',
      'fa-brands fa-rev',
      'fa-brands fa-rocketchat',
      'fa-brands fa-rockrms',
      'fa-brands fa-rust',
      'fa-brands fa-safari',
      'fa-brands fa-salesforce',
      'fa-brands fa-sass',
      'fa-brands fa-schlix',
      'fa-brands fa-scribd',
      'fa-brands fa-searchengin',
      'fa-brands fa-sellcast',
      'fa-brands fa-sellsy',
      'fa-brands fa-servicestack',
      'fa-brands fa-shirtsinbulk',
      'fa-brands fa-shopify',
      'fa-brands fa-shopware',
      'fa-brands fa-simplybuilt',
      'fa-brands fa-sistrix',
      'fa-brands fa-sith',
      'fa-brands fa-sketch',
      'fa-brands fa-skyatlas',
      'fa-brands fa-skype',
      'fa-brands fa-slack-hash',
      'fa-brands fa-slack',
      'fa-brands fa-slideshare',
      'fa-brands fa-snapchat-ghost',
      'fa-brands fa-snapchat-square',
      'fa-brands fa-snapchat',
      'fa-brands fa-soundcloud',
      'fa-brands fa-sourcetree',
      'fa-brands fa-speakap',
      'fa-brands fa-speaker-deck',
      'fa-brands fa-spotify',
      'fa-brands fa-squarespace',
      'fa-brands fa-stack-exchange',
      'fa-brands fa-stack-overflow',
      'fa-brands fa-stackpath',
      'fa-brands fa-staylinked',
      'fa-brands fa-steam-square',
      'fa-brands fa-steam-symbol',
      'fa-brands fa-steam',
      'fa-brands fa-sticker-mule',
      'fa-brands fa-strava',
      'fa-brands fa-stripe-s',
      'fa-brands fa-stripe',
      'fa-brands fa-studiovinari',
      'fa-brands fa-stumbleupon-circle',
      'fa-brands fa-stumbleupon',
      'fa-brands fa-superpowers',
      'fa-brands fa-supple',
      'fa-brands fa-suse',
      'fa-brands fa-swift',
      'fa-brands fa-symfony',
      'fa-brands fa-teamspeak',
      'fa-brands fa-telegram-plane',
      'fa-brands fa-telegram',
      'fa-brands fa-tencent-weibo',
      'fa-brands fa-the-red-yeti',
      'fa-brands fa-themeco',
      'fa-brands fa-themeisle',
      'fa-brands fa-think-peaks',
      'fa-brands fa-tiktok',
      'fa-brands fa-trade-federation',
      'fa-brands fa-trello',
      'fa-brands fa-tumblr-square',
      'fa-brands fa-tumblr',
      'fa-brands fa-twitch',
      'fa-brands fa-twitter-square',
      'fa-brands fa-twitter',
      'fa-brands fa-typo3',
      'fa-brands fa-uber',
      'fa-brands fa-ubuntu',
      'fa-brands fa-uikit',
      'fa-brands fa-umbraco',
      'fa-brands fa-uncharted',
      'fa-brands fa-uniregistry',
      'fa-brands fa-unity',
      'fa-brands fa-unsplash',
      'fa-brands fa-untappd',
      'fa-brands fa-ups',
      'fa-brands fa-usb',
      'fa-brands fa-usps',
      'fa-brands fa-ussunnah',
      'fa-brands fa-vaadin',
      'fa-brands fa-viacoin',
      'fa-brands fa-viadeo-square',
      'fa-brands fa-viadeo',
      'fa-brands fa-viber',
      'fa-brands fa-vimeo-square',
      'fa-brands fa-vimeo-v',
      'fa-brands fa-vimeo',
      'fa-brands fa-vine',
      'fa-brands fa-vk',
      'fa-brands fa-vnv',
      'fa-brands fa-vuejs',
      'fa-brands fa-watchman-monitoring',
      'fa-brands fa-waze',
      'fa-brands fa-weebly',
      'fa-brands fa-weibo',
      'fa-brands fa-weixin',
      'fa-brands fa-whatsapp-square',
      'fa-brands fa-whatsapp',
      'fa-brands fa-whmcs',
      'fa-brands fa-wikipedia-w',
      'fa-brands fa-windows',
      'fa-brands fa-wix',
      'fa-brands fa-wizards-of-the-coast',
      'fa-brands fa-wodu',
      'fa-brands fa-wolf-pack-battalion',
      'fa-brands fa-wordpress-simple',
      'fa-brands fa-wordpress',
      'fa-brands fa-wpbeginner',
      'fa-brands fa-wpexplorer',
      'fa-brands fa-wpforms',
      'fa-brands fa-wpressr',
      'fa-brands fa-xbox',
      'fa-brands fa-xing-square',
      'fa-brands fa-xing',
      'fa-brands fa-y-combinator',
      'fa-brands fa-yahoo',
      'fa-brands fa-yammer',
      'fa-brands fa-yandex-international',
      'fa-brands fa-yandex',
      'fa-brands fa-yarn',
      'fa-brands fa-yelp',
      'fa-brands fa-yoast',
      'fa-brands fa-youtube-square',
      'fa-brands fa-youtube',
      'fa-brands fa-zhihu',


    ]); // Lista completa de íconos
    
    // Variables reactivas para el buscador
    const searchQuery = ref('');
    const filteredIcons = ref([]);
    const currentIcon = ref(props.modelValue);
    const isOpen = ref(false);
    
    // Inicializar filteredIcons después de que allIcons esté disponible
    filteredIcons.value = [...allIcons.value];

    // Función para filtrar iconos
    const filterIcons = () => {
      if (!searchQuery.value.trim()) {
        filteredIcons.value = [...allIcons.value];
      } else {
        const query = searchQuery.value.toLowerCase().trim();
        filteredIcons.value = allIcons.value.filter(icon => {
          // Buscar en el nombre del icono (sin el prefijo fa-solid, fa-regular, etc.)
          const iconName = icon.replace(/^fa-(solid|regular|brands)\s+/, '');
          return iconName.toLowerCase().includes(query) || icon.toLowerCase().includes(query);
        });
      }
    };

    const positionDropdown = () => {
      nextTick(() => {
        const dropdown = document.querySelector('.icon-dropdown');
        const button = document.querySelector('.current-icon');
        if (!dropdown || !button) return;

        const buttonRect = button.getBoundingClientRect();
        const dropdownWidth = dropdown.offsetWidth || 500;
        const dropdownHeight = dropdown.offsetHeight || 400;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const margin = 10;

        let left = buttonRect.left;
        let top = buttonRect.bottom + 5;

        // Ajustar horizontalmente si se sale por la derecha
        if (left + dropdownWidth > viewportWidth - margin) {
          left = viewportWidth - dropdownWidth - margin;
        }
        // Ajustar si se sale por la izquierda
        if (left < margin) {
          left = margin;
        }

        // Ajustar verticalmente si se sale por abajo
        if (top + dropdownHeight > viewportHeight - margin) {
          // Intentar mostrar arriba del botón
          if (buttonRect.top - dropdownHeight > margin) {
            top = buttonRect.top - dropdownHeight - 5;
          } else {
            // Si no cabe arriba, ajustar altura máxima
            top = viewportHeight - dropdownHeight - margin;
          }
        }

        dropdown.style.left = `${left}px`;
        dropdown.style.top = `${top}px`;
      });
    };

    const toggleDropdown = () => {
      isOpen.value = !isOpen.value;
      if (isOpen.value) {
        // Resetear búsqueda al abrir
        searchQuery.value = '';
        filteredIcons.value = [...allIcons.value];
        // Enfocar el campo de búsqueda y posicionar el dropdown
        nextTick(() => {
          const searchInput = document.querySelector('.search-input');
          if (searchInput) {
            searchInput.focus();
          }
          // Posicionar el dropdown dentro de la pantalla
          positionDropdown();
        });
      }
    };

    const selectIcon = (icon) => {
      emit('update:modelValue', icon); // Actualiza el modelo
      isOpen.value = false; // Cierra el desplegable
      currentIcon.value = icon;
      searchQuery.value = ''; // Limpiar búsqueda
      nextTick(() => {
        
      });
    };

    // Sincroniza el modelo si cambia desde el padre
    watch(() => props.modelValue, (newVal) => {
      currentIcon.value = newVal;
    });

    return {
      allIcons,
      filteredIcons,
      searchQuery,
      currentIcon,
      isOpen,
      toggleDropdown,
      selectIcon,
      filterIcons,
      positionDropdown,
    };
  },
};
</script>

<style>
.icon-selector {
  position: relative;
  display: inline-block;
}

.current-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid #ccc;
  background: white;
  padding: 7px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
}

.icon-dropdown {
  position: fixed;
  z-index: 1000;
  width: 90vw;
  max-width: 500px;
  max-height: 70vh;
  border: 1px solid #ccc;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.search-container {
  padding: 12px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
}

.search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
}

.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.search-results-count {
  margin-top: 6px;
  font-size: 12px;
  color: #666;
  text-align: center;
}

.icon-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr); /* 6 columnas */
  gap: 8px;
  padding: 12px;
  max-height: calc(70vh - 100px);
  overflow-y: auto;
}

.no-results {
  padding: 40px 20px;
  text-align: center;
  color: #666;
}

.no-results i {
  font-size: 48px;
  color: #ddd;
  margin-bottom: 16px;
  display: block;
}

.no-results p {
  margin: 0;
  font-size: 14px;
}

.icon-grid button {
  border: 1px solid #eee;
  background: white;
  cursor: pointer;
  font-size: 20px;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

.icon-grid button:hover {
  background: #f8f9fa;
  border-color: #007bff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.icon-grid button.selected {
  color: #007bff;
  background: #e3f2fd;
  border-color: #007bff;
  font-weight: bold;
}

.icon-grid button i {
  pointer-events: none; /* Evita que los clics sean interceptados por el ícono */
}
</style>
